export default __webpack_public_path__ + "static/media/emptyBetslip.3d5e5326.png";